import { render, staticRenderFns } from "./forRent.vue?vue&type=template&id=27937121&scoped=true"
import script from "./forRent.vue?vue&type=script&lang=js"
export * from "./forRent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27937121",
  null
  
)

export default component.exports